export const SEARCHCARD_OWNERS = {
	PRIVATE: "PRIVATE",
	COMPANY: "COMPANY",
	PROJECT: "PROJECT",
};
